import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {CreateProductionJobComponent} from '../../production/create-production-job/create-production-job.component';
import { APIService } from '../../api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-production-job-creation',
  templateUrl: './production-job-creation.component.html',
  styleUrls: ['./production-job-creation.component.scss']
})
export class ProductionJobCreationComponent implements OnInit, AfterViewInit {
  @Input() mdlRef: any;
  @Input() prTypeID: number = 1;
  // @Input() isFromProjectMod: boolean = false;
  productionList:any = [];
  closeResult: any;
  modalReference: any;
  Cfg_AgnCfg:any = [];
  billables:any = [];
  jarvisData: any = [];
  MTbl: any = [];
  tempProductList: any = [];
  search: string = "";
  prodJobParam: any = this.commonService.GetParam('J');
  showAsPage: boolean = false;

  constructor(private modalService: NgbModal, private apiService: APIService, private commonService: CommonService, private route: ActivatedRoute ) { }

  ngOnInit(): void {

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    var tblM = this.apiService.getCookie('M');
    if (tblM) {
      this.MTbl = JSON.parse(tblM);
    }

    if(this.prodJobParam == 1) {
      this.showAsPage = true;
    }
    this.getOrderList();
  }

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          this.open('');
        }, 100);
      }
    });
  }

 //   open(content: any) {
   
//     this.modalReference = this.modalService.open(CreateProductionJobComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class'});
//   this.modalReference.result.then((result: any) => {
//     this.closeResult = `Closed with: ${result}`;
//   }, (reason: any) => {
//     this.closeResult = `Dismissed`;
//   });

//  this.modalReference.componentInstance.mdlRef = this.productionList
// }

getOrderList() {
  let tempData = [{
    'statusID': '1' //only pending order are required that's why statusID = 1
  }]

  let myParams = [{
    myUserID: this.jarvisData[0].UserID,
    myToken: this.jarvisData[0].WebToken,
    forAgencyID: this.jarvisData[0].AgencyIDs,
    myAgencyIDs: this.jarvisData[0].AgencyIDs,
    ForERPAgencyID: this.MTbl[0].ERPAgencyID,
    myLastSyncDT: null,
    isWeb: true,
    actionType: 'getOrdersForPrd',
    moduleID: 8,
    data: JSON.stringify(tempData)
  }];

  this.apiService.getData(myParams, this.successOrderList.bind(this), this.failureOrderList.bind(this))
}

successOrderList(res: any) {
  if (res.error) {
  } else {
    if (res) {
      var reponseData = JSON.parse(res.updatePackage);
      if (reponseData) {
        this.tempProductList = reponseData.Table1;
        if (this.tempProductList) {
          var tempData = this.tempProductList;
          for(let i = 0 ; i < tempData.length ; i++ ){
            let tempItem = JSON.parse(tempData[i].OrdItemList)
            if(tempItem){
              let tmpOrdData = tempItem.filter((x: any) => x.ItemID > 0)
              if(tmpOrdData.length > 0){
                this.productionList.push(tempData[i])
              }
              // if(tempItem[0].ItemID > 0){
              //   this.productionList.push(tempData[i])
              // }
            }
          }
        }
          
        if(this.productionList.length == 0) {
          let a = document.getElementById('withoutOrder');
          a?.click();
        }
    
        let temp_Cfg_AgnCfg= this.apiService.getCookie("Cfg_AgnCfg")
        if (temp_Cfg_AgnCfg) {
          this.Cfg_AgnCfg = JSON.parse(temp_Cfg_AgnCfg);
    
          let tempBillables = this.Cfg_AgnCfg[0].Billables 
          if(tempBillables){
            this.billables = JSON.parse(tempBillables)
          }
    
        }
        this.productionList.forEach((x:any) => {
          if(x.OrdItemList ){
            var temp = JSON.parse(x.OrdItemList);
            x.Item = temp[0].Item
            x.ItemID = temp[0].ItemID
            x.SU =  temp[0].SU
            x.OrderQty = temp[0].OrderQty
            x.DueDT = temp[0].DueDT
          }
          else{
            x.Item = ''
            x.ItemID = ''
            x.SU =  ''
            x.OrderQty = ''
            x.DueDT = null
          }
        });
      }
    }
  }
}

failureOrderList(res: any) {
  if (res.error) {
  } else {
      alert(res.message);
  }
}

open(content: any) {
  this.modalReference = this.modalService.open(CreateProductionJobComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
  this.modalReference.componentInstance.mdlRef = this.modalReference;
  this.modalReference.componentInstance.prTypeID = this.prTypeID;

  this.modalReference.result.then((result: any) => {
    if ( (result && result.action == 'Done') || ( this.prTypeID == 2 && this.tempProductList && this.tempProductList.length == 0 ) ) {
      this.mdlRef.close(result);
    
      }
  })
}


openWithOrder(content: any, obj:any) {

  this.modalReference = this.modalService.open(CreateProductionJobComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
  this.modalReference.componentInstance.mdlRef = this.modalReference;
  this.modalReference.componentInstance.Data = obj;
  this.modalReference.componentInstance.prTypeID = this.prTypeID;

  this.modalReference.result.then((result: any) => {
    if (result.action == 'Done') {
    
      this.mdlRef.close(result);
    
      }
  })
}

backToHomeBtn() {
  window.location.href = "https://biziverse.com/main.html#/home";
}


possibleOnCloseEvet() { 
  //Do some actions....

  alert("hello")
}

close(){
  this.mdlRef.close();

}
  
 


}
